export const ON_CONNECTION_ESTABLISHED = 'connect'
export const ON_SOCKET_CONNECTION_ERROR = 'error'
export const ON_SOCKET_CONNECTION_FAILED = 'connect_failed'
export const ON_SOCKET_DISCONNECTED = 'disconnect'
export const ON_CONVERSATION_ACCEPTED = 'acceptedChat'
export const ON_CHAT_STARTED_BY_OPERATOR = 'raychat_start_chat_with_agent'
export const ON_CONVERSATION_CLOSED = 'conversationClosed'
export const ON_USER_IS_BANNED = 'rayachat_userIsBanned'
export const ON_MESSAGE_BROADCASTED = 'broadcast_message'
export const ON_NEW_MESSAGE_RECEIVED = 'raychat_newMessage'
export const ON_OPERATOR_EDITED_MSG = 'userEditedMessage'
export const ON_MESSAGE_SEEN_BY_OPERATOR = 'conversationSeen'
export const ON_WIDGET_READY = 'raychat_ready'
export const ON_SENT_CLOSE_BUTTON = 'askToClose'
